/**
 * ScrollRegionUtil - I answer questions about where a scrolling box has got to. ONLY concerned
 * with reading it - no listeners, no state, no scrolling.
 */
export const ScrollRegionUtil = {
  /**
   * Whether the reader is far enough from the end to be worth offering a way back.
   *
   * **A fraction of the box rather than a pixel count**, so the trigger point scales with it
   * instead of meaning one thing in a panel and something else full-screen.
   */
  isAwayFromBottom({
    scroller,
    threshold,
  }: {
    scroller: Element;
    threshold: number;
  }) {
    const remaining =
      scroller.scrollHeight - scroller.scrollTop - scroller.clientHeight;

    return remaining > scroller.clientHeight * threshold;
  },
};
